(function(){
  var T = window.theme || {};
  function money(cents){
    var f = T.moneyFormat || '{{amount}} Kč';
    var n = (cents/100);
    function fmt(num, dec, th, de){
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(de);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      switch(k){
        case 'amount': return fmt(n,2,',','.');
        case 'amount_no_decimals': return fmt(n,0,',','.');
        case 'amount_with_comma_separator': return fmt(n,2,'.',',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n,0,'.',',');
        case 'amount_with_space_separator': return fmt(n,2,' ',',');
        case 'amount_no_decimals_with_space_separator': return fmt(n,0,' ',',');
        case 'amount_with_apostrophe_separator': return fmt(n,2,"'",'.');
        default: return fmt(n,2,' ',',');
      }
    }).replace(/<[^>]+>/g,'');
  }
  var drawer = document.getElementById('cart-drawer'), veil = document.getElementById('cart-veil');
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; el.hidden = !n; }); }
  function render(cart){
    var S = T.strings, body = drawer.querySelector('[data-cart-body]');
    drawer.querySelector('[data-cart-title]').textContent = S.bag + ' (' + cart.item_count + ')';
    setCount(cart.item_count);
    if (!cart.item_count){
      body.innerHTML = '<div class="dr-empty"><p class="serif">'+esc(S.empty)+'</p><a href="'+T.shopUrl+'" class="lnk up">'+esc(S.continue)+'</a></div>';
      return;
    }
    var items = cart.items.map(function(it, i){
      var img = it.image ? '<img src="'+it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=200" alt="">' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="ci"><div class="th">'+img+'</div><div class="ci-m"><b class="up small">'+esc(it.product_title)+'</b>'+(variant?'<span class="tiny">'+esc(variant)+'</span>':'')+Object.keys(it.properties||{}).filter(function(k){ return k.charAt(0)!=='_' && it.properties[k]; }).map(function(k){ return '<span class="tiny">'+esc(k)+': '+esc(it.properties[k])+'</span>'; }).join('')+
        '<div class="qty sm"><button data-line="'+(i+1)+'" data-q="'+(it.quantity-1)+'" aria-label="−">−</button><span>'+it.quantity+'</span><button data-line="'+(i+1)+'" data-q="'+(it.quantity+1)+'" aria-label="+">+</button></div></div>'+
        '<div class="ci-r"><button class="x" data-line="'+(i+1)+'" data-q="0" aria-label="'+esc(S.remove)+'">×</button><span>'+money(it.final_line_price)+'</span></div></div>';
    }).join('');
    var left = T.freeShipping - cart.total_price;
    var ship = left > 0 ? S.freeLeft.replace('__LEFT__', money(left)) : S.freeYes;
    var pct = T.freeShipping ? Math.min(100, cart.total_price / T.freeShipping * 100) : 100;
    body.innerHTML = '<div class="dr-items">'+items+'</div><div class="dr-f"><div class="row"><span>'+esc(S.subtotal)+'</span><span>'+money(cart.total_price)+'</span></div>'+
      '<p class="small">'+esc(ship)+'</p><div class="bar"><span style="width:'+pct+'%"></span></div><p class="tiny">'+esc(S.taxes)+'</p><p class="tiny cart-legal">'+(S.legal||'')+'</p>'+
      '<a href="/checkout" class="btn up">'+esc(S.checkout)+' →</a></div>';
  }
  function load(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(render); }
  function open(){ drawer.hidden = false; veil.hidden = false; document.body.style.overflow='hidden'; load(); }
  function close(){ drawer.hidden = true; veil.hidden = true; document.body.style.overflow=''; }
  window.DaydeeCart = { open: open, close: close };
  document.addEventListener('click', function(e){
    var o = e.target.closest('[data-open-cart]'); if (o && drawer){ e.preventDefault(); open(); return; }
    if (e.target.closest('[data-close-cart]')){ e.preventDefault(); close(); return; }
    var l = e.target.closest('[data-line]');
    if (l){ e.preventDefault(); fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:+l.dataset.line,quantity:+l.dataset.q})}).then(function(r){return r.json();}).then(render); }
    var q = e.target.closest('[data-qty]');
    if (q){ var input = document.getElementById(q.getAttribute('data-target')); if (input){ input.value = Math.max(1, (+input.value||1) + (+q.dataset.qty)); document.getElementById(q.getAttribute('data-target')+'-label').textContent = input.value; } }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && !drawer.hidden) close(); });
  document.addEventListener('submit', function(e){
    var f = e.target; if (!f.matches('[data-product-form]') || !drawer) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); btn.disabled = true;
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
      .then(function(){ btn.disabled = false; open(); })
      .catch(function(err){ btn.disabled = false; var m = f.querySelector('[data-form-error]'); if (m) m.textContent = (err && (err.description || err.message)) || 'Error'; });
  });
  document.querySelectorAll('[data-variant-select]').forEach(function(sel){
    sel.addEventListener('change', function(){
      var o = sel.options[sel.selectedIndex];
      var root = sel.closest('.buy');
      root.querySelector('[data-price]').textContent = o.dataset.price;
      var b = root.querySelector('[type=submit]'); var avail = o.dataset.available === 'true';
      b.disabled = !avail; b.querySelector('span').textContent = avail ? T.strings.add : T.strings.soldOut;
      var url = new URL(location.href); url.searchParams.set('variant', o.value); history.replaceState(null,'',url);
    });
  });
})();
(function(){
  var nav = document.getElementById('mnav');
  document.addEventListener('click', function(e){
    if (!nav) return;
    var o = e.target.closest('[data-menu-open]'), c = e.target.closest('[data-menu-close]');
    if (o){ nav.hidden = false; document.body.style.overflow='hidden'; o.setAttribute('aria-expanded','true'); }
    if (c){ nav.hidden = true; document.body.style.overflow=''; var b=document.querySelector('[data-menu-open]'); if(b) b.setAttribute('aria-expanded','false'); }
  });
  document.addEventListener('keydown', function(e){ if (e.key==='Escape' && nav && !nav.hidden){ nav.hidden = true; document.body.style.overflow=''; } });
  var bar = document.querySelector('[data-sticky-buy]'), main = document.querySelector('[data-main-buy]');
  if (bar && main && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      var e = en[0], past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('show', past); bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      bar.querySelector('button').tabIndex = past ? 0 : -1;
    }).observe(main);
  }
})();

document.addEventListener('click', function(e){
  var c = e.target.closest('[data-cookie-settings]'); if (!c) return;
  e.preventDefault();
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); }
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function(){ if (window.privacyBanner) window.privacyBanner.showPreferences(); });
  }
});
